import { createContext, useContext, useState, useEffect, ReactNode } from "react";

type Lang = "en" | "ar";

type LangContextType = {
  lang: Lang;
  toggleLang: () => void;
  t: (en: string, ar: string) => string;
};

const LangContext = createContext<LangContextType | null>(null);

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>(() => {
    const saved = localStorage.getItem("lang");
    return saved === "en" ? "en" : "ar";
  });

  const t = (en: string, ar: string) => lang === "en" ? en : ar;

  const toggleLang = () => {
    setLang(prev => prev === "en" ? "ar" : "en");
  };

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    localStorage.setItem("lang", lang);
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
